

const updatePageMetaTitle = (page) => {
    // Update page title based on current page
    const titleElement = document.querySelector('title');
    if (titleElement) {
        // Extract base title by removing any existing page number and TRYBA suffix
        let baseTitle = titleElement.textContent || '';
        baseTitle = baseTitle.replace(/ - Page \d+/, '').replace(/ \| TRYBA$/, '').trim();

        if (page > 1) {
            titleElement.textContent = `${baseTitle} - Page ${page} | TRYBA`;
        } else {
            titleElement.textContent = `${baseTitle} | TRYBA`;
        }
    }
}

const updatePageTitle = (page) => {
    // Update h1 heading based on current page (without TRYBA suffix)
    const h1Element = document.querySelector('h1');
    if (h1Element) {
        // Extract base heading by removing any existing page number
        let baseHeading = h1Element.textContent || '';
        baseHeading = baseHeading.replace(/ - Page \d+/, '').trim();

        if (page > 1) {
            h1Element.textContent = `${baseHeading} - Page ${page}`;
        } else {
            h1Element.textContent = baseHeading;
        }
    }
}

const updatePageCanonical = (page: number) => {
    // on met a jour la canonical avec l'URL courante
    const canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement|null;
    if (canonical) {
        const url = new URL(window.location.href);
        const newUrl = url.origin + url.pathname + (page > 1 ? `?page=${page}` : '');
        canonical.setAttribute('href', newUrl);
    }
}

export {
    updatePageMetaTitle,
    updatePageTitle,
    updatePageCanonical,
}
